(function () {
  if (window.__shippingInsuranceToggleAssetInitialized) return;
  window.__shippingInsuranceToggleAssetInitialized = true;

  const COLLAPSED_STORAGE_KEY = 'shippingPriorityToggleCollapsed';

  function getRoute(name, fallback) {
    return (window.Theme && Theme.routes && Theme.routes[name]) || fallback;
  }

  function getCartAddUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
  }

  function getCartJsonUrl() {
    const cartUrl = getRoute('cart_url', '/cart');
    return cartUrl.indexOf('.js') === -1 ? cartUrl + '.js' : cartUrl;
  }

  function getJsonRoute(name, fallback) {
    const route = getRoute(name, fallback);
    return route.indexOf('.js') === -1 ? route + '.js' : route;
  }

  async function getCart() {
    const res = await fetch(getCartJsonUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function dispatchCartUpdate(resource, sections) {
    const drawersToRestore = [];

    document.querySelectorAll('cart-drawer-component[auto-open]').forEach(function (drawer) {
      drawer.removeAttribute('auto-open');
      drawersToRestore.push(drawer);
    });

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: resource,
          sourceId: 'shipping-insurance-toggle',
          data: {
            source: 'shipping-insurance-toggle',
            itemCount: resource && typeof resource.item_count === 'number' ? resource.item_count : 0,
            variantId: resource && resource.variant_id ? String(resource.variant_id) : undefined,
            sections: sections || {},
          },
        },
      })
    );

    drawersToRestore.forEach(function (drawer) {
      drawer.setAttribute('auto-open', '');
    });
  }

  function refreshCartAfterDelay() {
    window.setTimeout(async function () {
      try {
        const updatedCart = await getCart();
        dispatchCartUpdate(updatedCart, {});
      } catch (cartError) {
        console.warn('Shipping insurance changed, but cart refresh failed:', cartError);
      }
    }, 650);
  }

  function setFeedback(feedback, message) {
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.classList.toggle('si-toggle__feedback--error', Boolean(message));
  }

  function setCollapsed(root, collapsed) {
    if (!root) return;
    root.classList.toggle('si-toggle--collapsed', collapsed);
    try {
      window.sessionStorage.setItem(COLLAPSED_STORAGE_KEY, collapsed ? '1' : '0');
    } catch (error) {}
  }

  function applyCollapsedPreference() {
    let collapsed = false;
    try {
      collapsed = window.sessionStorage.getItem(COLLAPSED_STORAGE_KEY) === '1';
    } catch (error) {}

    document.querySelectorAll('[data-si-toggle-root]').forEach(function (root) {
      root.classList.toggle('si-toggle--collapsed', collapsed);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const collapseButton =
        event.target && event.target.closest ? event.target.closest('[data-si-collapse]') : null;
      const expandButton = event.target && event.target.closest ? event.target.closest('[data-si-expand]') : null;
      const button = collapseButton || expandButton;
      if (!button) return;

      const root = button.closest('[data-si-toggle-root]');
      if (!root) return;

      event.preventDefault();
      setCollapsed(root, Boolean(collapseButton));
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCollapsedPreference);
  } else {
    applyCollapsedPreference();
  }
  document.addEventListener('cart:update', function () {
    window.setTimeout(applyCollapsedPreference, 0);
  });

  document.addEventListener(
    'change',
    function (event) {
      const checkbox = event.target && event.target.closest ? event.target.closest('.si-toggle__input') : null;
      if (!checkbox) return;

      event.stopImmediatePropagation();

      const wrapper = checkbox.closest('.si-toggle');
      if (!wrapper) return;

      const feedback = wrapper.querySelector('.si-toggle__feedback');
      const variantId = checkbox.dataset.variantId;
      if (!variantId) {
        checkbox.checked = false;
        setFeedback(feedback, 'Missing variant ID.');
        console.error('Shipping insurance add failed: missing variant id.');
        return;
      }

      setFeedback(feedback, '');

      function setLoading(on) {
        wrapper.classList.toggle('si-toggle--loading', on);
        checkbox.disabled = on;
      }

      async function addInsurance() {
        setLoading(true);
        setFeedback(feedback, '');

        try {
          const currentCart = await getCart();
          const existingItem = currentCart.items.find(function (item) {
            return String(item.variant_id) === String(variantId);
          });

          if (existingItem) {
            checkbox.checked = true;
            dispatchCartUpdate(currentCart, {});
            return;
          }

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          const res = await fetch(getCartAddUrl(), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: formData,
          });
          const data = await res.json().catch(function () {
            return {};
          });

          if (!res.ok || data.status) {
            setFeedback(feedback, data.description || data.message || 'Shopify rejected /cart/add.js.');
            console.error('Shipping insurance add response:', data);
            throw new Error(data.message || data.description || 'add failed');
          }

          checkbox.checked = true;
          setFeedback(feedback, '');
          refreshCartAfterDelay();
        } catch (error) {
          checkbox.checked = false;
          if (!feedback || !feedback.textContent) {
            setFeedback(feedback, 'Could not add Priority Processing.');
          }
          console.error('Shipping insurance add failed:', error);
        } finally {
          setLoading(false);
        }
      }

      async function removeInsurance() {
        setLoading(true);
        setFeedback(feedback, '');

        try {
          const currentCart = await getCart();
          const item = currentCart.items.find(function (cartItem) {
            return String(cartItem.variant_id) === String(variantId);
          });

          if (!item) {
            checkbox.checked = false;
            dispatchCartUpdate(currentCart, {});
            return;
          }

          const res = await fetch(getJsonRoute('cart_change_url', '/cart/change.js'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
          });
          const data = await res.json();

          if (!res.ok || data.errors) {
            setFeedback(feedback, data.errors || 'Shopify rejected /cart/change.js.');
            throw new Error('remove failed');
          }

          checkbox.checked = false;
          refreshCartAfterDelay();
        } catch (error) {
          checkbox.checked = true;
          if (!feedback || !feedback.textContent) {
            setFeedback(feedback, 'Could not remove Priority Processing.');
          }
          console.error('Shipping insurance remove failed:', error);
        } finally {
          setLoading(false);
        }
      }

      if (checkbox.checked) {
        addInsurance();
      } else {
        removeInsurance();
      }
    },
    true
  );
})();
